import { ReactNode } from 'react';
import { createEvent, createStore } from 'effector';

interface AiModal {
  title: string | ReactNode;
  content?: string | ReactNode;
  buttons?: {
    text: string;
    main?: boolean;
    classes?: string[];
    size?: string;
    onClick?: () => void;
  }[];
}

export const openAiModalEvent = createEvent<AiModal>();
export const closeAiModalEvent = createEvent();
export const $aiModal = createStore<AiModal | null>(null)
  .on(openAiModalEvent, (_, payload) => payload)
  .reset(closeAiModalEvent);
